"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = videoInputDevice;
var _types = require("../../actions/meeting/types");
var _amazonChimeSdkJs = require("amazon-chime-sdk-js");
function videoInputDevice() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === _types.BROADCAST_SET_VIDEO_DEVICE) {
    // If the device is a DefaultVideoTransformDevice, we want to store the
    // device itself instead of the deviceId. This is because to start a video,
    // we need to pass the device or deviceId to the SDK.
    if (action.payload.deviceId instanceof _amazonChimeSdkJs.DefaultVideoTransformDevice) {
      return action.payload.deviceId;
    }
    return action.payload;
  }
  return state;
}